export const MIN_YEAR = 1800 as const;
export const MAX_YEAR = 2050 as const;
export const MAX_NUMBER = 1e21 as const;
export const MAX_SAFE_INTEGER = 9007199254740991 as const;

export const MAX_INT_32_NUMBER = 2147483647 as const;
export const ERROR_TYPES = {
    INVALID_DATE_RANGE: 'INVALID_DATE_RANGE',
    MAX_NUMBER_ERROR: 'MAX_NUMBER_ERROR',
    WRONG_DATE: 'WRONG_DATE',
    WRONG_HTTP_PORT: 'WRONG_HTTP_PORT',
    WRONG_MONTH: 'WRONG_MONTH',
    WRONG_NUMBER_VALUE: 'WRONG_NUMBER_VALUE',
    WRONG_YEAR: 'WRONG_YEAR',
} as const;

export const ValidType = {
    DATE: 'date',
    DATE_RANGE: 'date-range',
    FULL_DATE: 'full-date',
    HTTP_PORT: 'http-port',
    INT: 'int',
    INT_32: 'int-32',
    INT_NUMBER_0_TO_100: 'int-number-0-to-100',
    INT_POSITIVE: 'int-positive',
    MAX_SAFE_NUMBER: 'max-safe-number',
    MAX_SAFE_NUMBER_POSITIVE: 'max-safe-number-positive',
    NUMBER: 'number',
    NUMBER_0_TO_100: 'number-0-to-100',
    NUMBER_POSITIVE: 'number-positive',
    PHONE: 'phone',
    YEAR: 'year',
} as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ValidTypeValues = [...Object.values(ValidType)] as const;
export type ValidTypes = typeof ValidTypeValues[number];

export type UserLocaleDto = {
    dateFormat: string,
    decimalFormat: string,
    thousandFormat: string,
    formattedValue?: string,
};
export const ERROR_MESSAGES = {
    WRONG_YEAR: `Please enter a year between ${MIN_YEAR} and ${MAX_YEAR}.`,
    WRONG_MONTH: 'Please make sure the month you entered is a value from 1 to 12.',
    WRONG_DATE: 'Invalid date. Please re-enter the date in the correct format.',
    MAX_NUMBER_ERROR: 'Invalid number. Please re-enter the number in the correct format.',
    WRONG_NUMBER_VALUE: 'Please enter a value between 0 and 100.',
    WRONG_HTTP_PORT: 'Invalid http port. Please enter a positive number.',
    INVALID_DATE_RANGE: 'Invalid date range. Please re-enter the date range in the correct format.',
} as const;
